import React, { useRef } from 'react';

// Formato canônico usado pela API: 'YYYY-MM-DD HH:MM:SS' (ex.: 2026-07-16 00:00:00).
// O componente edita/emite exatamente essa string. Um picker nativo (datetime-local)
// preenche o campo, e há um botão opcional de "limpar" (emite '' => null/cascata).

export const DATETIME_RE = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

export const isValidDateTime = (v) => DATETIME_RE.test((v || '').trim());

// 'YYYY-MM-DD HH:MM:SS' (ou ISO 'YYYY-MM-DDTHH:MM:SS...') -> 'YYYY-MM-DDTHH:MM' p/ o input nativo
const toLocalInput = (v) => {
    if (!v) return '';
    const s = String(v).replace('T', ' ');
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ ]?(\d{2}):(\d{2})/);
    return m ? `${m[1]}-${m[2]}-${m[3]}T${m[4]}:${m[5]}` : '';
};

// 'YYYY-MM-DDTHH:MM' -> 'YYYY-MM-DD HH:MM:00'
const fromLocalInput = (v) => {
    if (!v) return '';
    const m = v.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})/);
    return m ? `${m[1]} ${m[2]}:${m[3]}:00` : '';
};

// Normaliza um valor vindo do backend (ISO com 'T'/frações) para o formato canônico.
export const toInitialDateTime = (v) => {
    if (!v) return '';
    const s = String(v).replace('T', ' ');
    const m = s.match(/^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2}):(\d{2})/);
    if (m) return `${m[1]} ${m[2]}:${m[3]}:${m[4]}`;
    const m2 = s.match(/^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2})/);
    return m2 ? `${m2[1]} ${m2[2]}:${m2[3]}:00` : '';
};

const DateTimeInputBR = ({ value, onChange, id, allowClear = false, placeholder = 'AAAA-MM-DD HH:MM:SS' }) => {
    const ref = useRef(null);
    return (
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            <input
                id={id}
                type="text"
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                className="form-input"
                placeholder={placeholder}
                maxLength={19}
                style={{ flex: 1 }}
            />
            <input
                ref={ref}
                type="datetime-local"
                step="1"
                style={{ position: 'absolute', opacity: 0, width: 0, height: 0, overflow: 'hidden' }}
                value={toLocalInput(value)}
                onChange={(e) => onChange(fromLocalInput(e.target.value))}
            />
            <button
                type="button"
                onClick={() => ref.current?.showPicker?.()}
                style={{ background: 'none', border: '1px solid #ccc', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '18px', lineHeight: 1 }}
                title="Abrir calendário"
            >
                📅
            </button>
            {allowClear && (
                <button
                    type="button"
                    onClick={() => onChange('')}
                    style={{ background: 'none', border: '1px solid #ccc', borderRadius: '6px', padding: '6px 10px', cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}
                    title="Limpar (zerar)"
                >
                    ✕
                </button>
            )}
        </div>
    );
};

export default DateTimeInputBR;
